// src/components/Profile/PersonalInfoSection.js
// Section informations personnelles (modifiable)

import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import profileService from '../../services/profileService';
import { formatPhoneDisplay } from '../../services/authService';

const PersonalInfoSection = () => {
  const { user, updateUserData } = useAuth();
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    city: '',
    country: 'Sénégal'
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });

  // Charger les données utilisateur
  useEffect(() => {
    if (user) {
      setFormData({
        firstName: user.first_name || user.firstName || '',
        lastName: user.last_name || user.lastName || '',
        email: user.email || '',
        address: user.address || '',
        city: user.city || '',
        country: user.country || 'Sénégal',
      });
    }
  }, [user]);

  // Gérer les changements
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    setMessage({ type: '', text: '' });
  };

  // Soumettre les modifications
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage({ type: '', text: '' });

    // Validation
    if (!formData.firstName || !formData.lastName) {
      setMessage({ type: 'error', text: 'Prénom et nom sont requis' });
      setLoading(false);
      return;
    }

    if (!formData.email) {
      setMessage({ type: 'error', text: 'Email est requis' });
      setLoading(false);
      return;
    }

    // Appel API
    const result = await profileService.updateProfile(formData);

    if (result.success) {
      setMessage({ type: 'success', text: 'Profil mis à jour avec succès' });
      // Mettre à jour le contexte
      if (updateUserData) {
        updateUserData(result.data);
      }
    } else {
      setMessage({ type: 'error', text: result.message });
    }

    setLoading(false);
  };

  return (
    <div className="personal-info-section">
      <h2>Informations personnelles</h2>
      <p className="section-subtitle">
        Gérez vos informations personnelles
      </p>

      <form onSubmit={handleSubmit} className="profile-form">
        
        {/* Prénom + Nom */}
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="firstName">Prénom</label>
            <input
              type="text"
              id="firstName"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              placeholder="Votre prénom"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="lastName">Nom</label>
            <input
              type="text"
              id="lastName"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              placeholder="Votre nom"
              required
            />
          </div>
        </div>

        {/* Email */}
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        {/* Téléphone (NON modifiable) */}
        <div className="form-group">
          <label htmlFor="phone">Téléphone</label>
          <input
            type="text"
            id="phone"
            value={formatPhoneDisplay(user?.phone || '')}
            disabled
            className="disabled-input"
          />
          <p className="field-note">
            Le numéro de téléphone ne peut pas être modifié
          </p>
        </div>

        {/* Adresse */}
        <div className="form-group">
          <label htmlFor="address">Adresse</label>
          <input
            type="text"
            id="address"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Ex: Plateau, Dakar"
          />
        </div>

        {/* Ville + Pays */}
        <div className="form-row">
          <div className="form-group">
            <label htmlFor="city">Ville</label>
            <input
              type="text"
              id="city"
              name="city"
              value={formData.city}
              onChange={handleChange}
              placeholder="Dakar"
            />
          </div>

          <div className="form-group">
            <label htmlFor="country">Pays</label>
            <select
              id="country"
              name="country"
              value={formData.country}
              onChange={handleChange}
            >
              <option value="Sénégal">Sénégal</option>
            </select>
          </div>
        </div>

        {/* Message */}
        {message.text && (
          <div className={`form-message ${message.type}`}>
            {message.type === 'success' ? '✅' : '⚠️'} {message.text}
          </div>
        )}

        {/* Bouton */}
        <button 
          type="submit" 
          className="btn-primary"
          disabled={loading}
        >
          {loading ? 'Enregistrement...' : 'Enregistrer les modifications'}
        </button>

      </form>
    </div>
  );
};

export default PersonalInfoSection;